import "jquery";
import "../src/fetchExternalData";
